import { Injectable, EventEmitter } from '@angular/core';
import { Church } from '../../models/church.model';

//import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { GeneralService } from '../general/general.service';
import { NotificationsService } from '../notifications/notifications.service';

@Injectable()
export class IglesiasService {
  //recetaCollection: AngularFirestoreCollection<any>;

  iglesiaCreada: boolean = false;

  terminoBuscar: string = '';

  allChurches: Church[] = [];

  /*
  constructor(public http: HttpClient,
    private afs: AngularFirestore) {
    this.recetaCollection = this.afs.collection('churches', ref => ref);
  }
  */

  constructor(public http: HttpClient,
    private _generalService: GeneralService,
    private _notificationsService: NotificationsService) {
  }

  /*
  subirIglesias(churches: Church[]) {
    for (let i = 0; i < churches.length - 1; i++) {
      this.recetaCollection.add(churches[i]);
    }

    return this.recetaCollection.add(churches[churches.length - 1]); // CUANDO LA ÚLTIMA IGLESIA SEA SUBIDA, RESOLVERÁ LA PROMESA
  }
  */

  /*
  crearIglesia(church: Church) {
    return this.recetaCollection.add(church);
  }
  */

  getChurches() {
    const token = localStorage.getItem('id_token');
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': token
    };

    return this.http.get(environment.apiEndPoint + '/iglesias', {
      headers
    });
  }

  getAllChurches() {
    return this.http.get(environment.apiEndPoint + '/iglesias/all');
  }

  getChurch(id: number) {
    return this.http.get(environment.apiEndPoint + '/iglesias/' + id, this._generalService.getHeadersUser());
  }

  updateChurch(church: Church) {
    return this.http.put(environment.apiEndPoint + '/iglesias/' + church.id, church, this._generalService.getHeadersUser());
  }

  newPendingChurch(church) {
    return this.http.post(environment.apiEndPoint + '/iglesias/pending', church);
  }

  deleteChurch(id: number) {
    return this.http.delete(environment.apiEndPoint + '/iglesias/' + id, this._generalService.getHeadersUser())
      .map(() => {
        this._notificationsService.pendingChurchesEvent.emit(true);
      })
  }

  /*
  getIglesia(id: string) {
    return this.recetaCollection.doc(id).ref.get();
  }
  */
  /*
    getIglesiasByTermino(): Promise<Church[]> {
      return new Promise((resolve, reject) => {
        this.recetaCollection.snapshotChanges().map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as Church;
            data.id = Number(a.payload.doc.id);
            return data;
          });
        })
          .subscribe((data) => {
            let iglesias = data.filter(iglesia => {
              if (this.compararCampos(this.terminoBuscar, iglesia)) {
                return true;
              }
              else {
                return false;
              }
  
            });
            resolve(iglesias);
          })
  
      })
    }
  */

  /*
  getIglesiaByNombre(nombre: string) {
    return new Promise((resolve, reject) => {
      this.getChurches()
        .subscribe((data) => {
                    
          for (let iglesia of JSON.parse(data['_body'])) {
            if ((iglesia.nombre.toLowerCase()).indexOf(nombre.toLowerCase()) >= 0) {
              resolve(iglesia);
            }
          }
          reject();

          
        })
    })
  }
*/
  getChurchesByTerm(value: string) {
    let churches: Church[] = [];
    return new Promise((resolve, reject) => {


      for (let iglesia of this.allChurches) {
        if (iglesia.name.toLowerCase().indexOf(value.toLowerCase()) >= 0) {
          churches.push(iglesia);
        }
      }
      resolve(churches);


    })
  }

  getChurchesByDistrict(id: number) {
    let churches: Church[] = [];
    return new Promise((resolve, reject) => {

      for (let iglesia of this.allChurches) {
        if (iglesia.city.sectional.district.id == id) {
          churches.push(iglesia);
        }
      }
      resolve(churches);

      /* for (let i = 0; i < this.allChurches.length; i++) {
        if (this.allChurches[i].city.sectional.district.id == id) {
          churches.push(this.allChurches[i]);
        }
      }
      
      console.log('ejecute resolve'); */
      resolve(churches);

    })
  }

  getChurchesBySectional(id: number) {
    let churches: Church[] = [];
    return new Promise((resolve, reject) => {

      for (let iglesia of this.allChurches) {
        if (iglesia.city.sectional.id == id) {
          churches.push(iglesia);
        }
      }

      resolve(churches);
    })
  }

  getChurchesByCity(id: number) {
    let churches: Church[] = [];
    return new Promise((resolve, reject) => {

      for (let iglesia of this.allChurches) {
        if (iglesia.city.id == id) {
          churches.push(iglesia);
        }
      }

      resolve(churches);

    })
  }

  getChurchById(id: number) {
    return new Promise((resolve, reject) => {

      let exist: boolean = false;

      for (let iglesia of this.allChurches) {
        if (iglesia.id == id) {
          exist = true;
          resolve(iglesia);
        }
      }

      if (!exist) {
        reject();
      }
    })
  }

  getIglesiasByDistancia(posicion: any, distancia: number) {

    return new Promise((resolve, reject) => {
      let iglesias: Church[] = [];

      this.getChurches()
        .subscribe((data) => {
          for (let iglesia of JSON.parse(data['_body'])) {
            if (typeof iglesia.lat !== 'undefined' && typeof iglesia.long !== 'undefined') {
              let diferencia = this.distance(posicion.latitude, posicion.longitude, iglesia.lat, iglesia.long, 'K');

              if (Math.floor(diferencia) <= distancia) {

                iglesias.push(iglesia);
              }
            }
          }

          if (iglesias.length >= 1) {
            resolve(iglesias);
          }
          else {
            reject();
          }

        });
    })
  }

  compararCampos(termino: string, iglesia: Church) {
    termino = termino.toLowerCase();
    if (
      iglesia.name.toLowerCase() == termino ||
      iglesia.phone.toLowerCase() == termino ||
      iglesia.email.toLowerCase() == termino
    ) {
      return true;
    }
    else {
      return false;
    }
  }

  sortIglesiasByNombre(iglesias: Church[]) {

    iglesias.sort(function (a, b) {
      var x = a.name.toLowerCase();
      var y = b.name.toLowerCase();
      if (x < y) { return -1; }
      if (x > y) { return 1; }
      return 0;
    });


    return iglesias;
  }

  distance(lat1, lon1, lat2, lon2, unit) {
    let radlat1 = Math.PI * lat1 / 180
    let radlat2 = Math.PI * lat2 / 180
    let theta = lon1 - lon2
    let radtheta = Math.PI * theta / 180
    let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist)
    dist = dist * 180 / Math.PI
    dist = dist * 60 * 1.1515
    if (unit == "K") { dist = dist * 1.609344 }
    if (unit == "N") { dist = dist * 0.8684 }
    return dist
  }

  getPendingChurches() {
    return this.http.get(environment.apiEndPoint + '/iglesias/pending', this._generalService.getHeadersUser());
  }

  approveChurch(id: number) {
    return this.http.post(environment.apiEndPoint + '/iglesias/approve', { id: id }, this._generalService.getHeadersUser())
      .map(() => {
        this._notificationsService.pendingChurchesEvent.emit(true);
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/services/iglesias/iglesias.service.ts